KXL.module('GamesApp.Masthead', function (Masthead, KXL, Backbone, Marionette, $, _) {
	Masthead.Controller = {
		getMasthead: function (options) {
			return new Masthead.View(options);
		}
	};
});
